import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface FieldErrorInfoIconProps {
  className?: string;
}

const FieldErrorInfoIcon = ({ className }: FieldErrorInfoIconProps) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      aria-hidden
    >
      <g clipPath="url(#clip0_305_841)">
        <path
          d="M7.00033 4.66667V7.00001M7.00033 9.33334H7.00616M12.8337 7.00001C12.8337 10.2217 10.222 12.8333 7.00033 12.8333C3.77866 12.8333 1.16699 10.2217 1.16699 7.00001C1.16699 3.77834 3.77866 1.16667 7.00033 1.16667C10.222 1.16667 12.8337 3.77834 12.8337 7.00001Z"
          stroke="#EF4444"
          strokeWidth="1.3125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_305_841">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);

export { FieldErrorInfoIcon };
